const PURPLE_60 = '#7C3AED';
const VIOLET_100 = '#B135CC';

const COLORS = {
  // Primary
  PURPLE_100: '#6B65E7',
  PURPLE_60,
  LIGHT_PURPLE_50: '#BAB7F4',
  DARK_PURPLE_100: '#625FA6',
  // Semantic
  GREEN_100: '#A1CCCF',
  GREEN_30: '#DBECED',
  YELLOW_100: '#FCC787',
  YELLOW_30: '#FEEEDB',
  VELVET_100: '#C39DFF',
  VELVET_30: '#EDE2FF',
  SALMON_100: '#FF8C78',
  SALMON_30: '#FFDDD7',
  PINK_100: '#F5BAC4',
  PINK_30: '#FCEAED',
  BLUE_100: '#3399FF',
  BLUE_30: '#C2E0FF',
  GRASS_100: '#9FCE8F',
  GRASS_30: '#E2F0DD',
  FUCHSIA_60: '#C026D3',
  PURPLE_PAYWALL_60: '#6E56FF',
  HIGHLIGHT_100: '#D0F972',
  VIOLET_100,
  VIOLET_90: '#4c1d95',
  VIOLET_50: '#F5F3FF',
  // Neutrals
  WHITE: '#FFFFFF',
  YELLOW_BG: '#FFFAF1',
  GRAY_BG_TRANSPARENT: '#FFFFFF73',
  GRAY_BG: '#F0F0F2',
  GRAY_5: '#F9FAFB',
  GRAY_10: '#F3F4F6',
  GRAY_20: '#E5E7EB',
  GRAY_30: '#D1D5DB',
  GRAY_40: '#A8A29E',
  GRAY_50: '#78716C',
  GRAY_60: '#4B5563',
  GRAY_70: '#44403C',
  GRAY_80: '#292524',
  OLD_GRAY_80: '#1F2937', // a great color name from Figma...
  GRAY_95: '#0C0A09',
  PURPLE_DISABLED: '#CCCAF0',
  PURPLE_CLICK: '#7671D7',
  BLACK: '#000000',
  BLACK_80: '#333333',
  BLACK_60: '#666666',
  BLACK_40: '#999999',
  BLACK_20: '#CCCCCC',
  BLACK_10: '#E6E6E6',
  // System
  // need to update to SYSTEM_RED_100
  RED_100: '#EF5350',
  SYSTEM_ORANGE: '#FF981D',
  SYSTEM_GREEN: '#3BB741',
  // Skin
  SKIN_TONE_1: '#FFEDDE',
  SKIN_TONE_2: '#E8BCA3',
  SKIN_TONE_3: '#9B663D',
  SKIN_TONE_4: '#544535',
  // Cream
  DARK_CREAM: '#F2EDE8',
  LIGHT_CREAM: '#FCFBF7',
  //gradient
  PURPLE_GRADIENT: `linear-gradient(92deg, ${PURPLE_60} 0%, ${VIOLET_100} 100%)`,
  // Beige
  BEIGE_2: '#FCFBF9',
  BEIGE_5: '#F9F6F3',
  BEIGE_10: '#F0EAE4',
  BEIGE_20: '#E0D3C8',
  BEIGE_30: '#CCB6A5',
  BEIGE_70: '#81584D',
  BEIGE_95: '#2E1F1C',
};

export type ColorType = keyof typeof COLORS;

export const getColor = (color: ColorType) => COLORS[color];

export const getTextColorProps = (color: ColorType) => {
  if (color === 'PURPLE_GRADIENT') {
    return `
      background: ${getColor(color)};
      background-clip: text;
      text-fill-color: transparent;
    `;
  }
  return `color: ${getColor(color)};`;
};

export const resetGradientColorProps = () => {
  return `
    background: initial;
    background-clip: initial;
    text-fill-color: initial;
  `;
};

// only for storybook
export const colorsKeys = Object.keys(COLORS);

// @TODO : Fix assets files/folder loading, this is a placeholder
export const ASSETS_BASE_DIR = '/assets';
